module.exports = __webpack_public_path__ + "images/history-shoot-90-9c36f8cdb1da5886d5cde0068ccfb9df.png";


/*****************
 ** WEBPACK FOOTER
 ** ./web/images/history-shoot-90.png
 ** module id = 386
 ** module chunks = 0
 **/